import { render, staticRenderFns } from "./AddBilling.vue?vue&type=template&id=5ff76cae&"
import script from "./AddBilling.vue?vue&type=script&lang=js&"
export * from "./AddBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports